import { render, staticRenderFns } from "./register.page.vue?vue&type=template&id=976a450a&"
import script from "./register.page.vue?vue&type=script&lang=ts&"
export * from "./register.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports